import { render, staticRenderFns } from "./painel-filtro-colapsavel.vue?vue&type=template&id=1a16a87a&scoped=true"
import script from "./painel-filtro-colapsavel.vue?vue&type=script&lang=ts"
export * from "./painel-filtro-colapsavel.vue?vue&type=script&lang=ts"
import style0 from "./painel-filtro-colapsavel.vue?vue&type=style&index=0&id=1a16a87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a16a87a",
  null
  
)

export default component.exports